// removed by extract-text-webpack-plugin
module.exports = {"button":"_kJWND","hide":"_2CpUG","icon":"_1kR7e","whiteIcon":"_3YdSR"};


//////////////////
// WEBPACK FOOTER
// ./app/components/LoginTypeSwitcher/LoginTypeSwitcher.scss
// module id = 1166
// module chunks = 1